export const blog_tags_data = [
  {
    key: "1",
    tags: "HRMS",
    created_date: "12/09/2024",
    status: "Active",
  },
  {
    key: "2",
    tags: "Recruitment",
    created_date: "24/10/2024",
    status: "Active",
  },
  {
    key: "3",
    tags: "HRTech",
    created_date: "18/02/2024",
    status: "Active",
  },
  {
    key: "4",
    tags: "HRMSFuture",
    created_date: "17/10/2024",
    status: "Active",
  },
  {
    key: "5",
    tags: "DataSecurity",
    created_date: "20/07/2024",
    status: "Active",
  },
  {
    key: "6",
    tags: "HRSoftware",
    created_date: "10/04/2024",
    status: "Active",
  },
  {
    key: "7",
    tags: "HRTrends",
    created_date: "29/08/2024",
    status: "Active",
  },
  {
    key: "8",
    tags: "HRMSBenefits",
    created_date: "22/02/2024",
    status: "Active",
  },
  {
    key: "9",
    tags: "	HRMSTools",
    created_date: "03/11/2024",
    status: "Active",
  },
  {
    key: "10",
    tags: "HRTechInnovation",
    created_date: "17/12/2024",
    status: "Active",
  },
];
